import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory, useParams } from 'react-router-dom';
import Base, { Breadcrumbs } from '../../layout';
import OrganisationServices from '../../services/organization.services';

const errorMessage = (error) => {
    return <div className="text-danger">{error}</div>;
};

const required = 'This field is required';
const maxLength = 'Your input exceed maximum length';
const CreateUpdateOrgAccount = () => {
    const history = useHistory();
    const defaultOrganisation = {
        name: '',
        description: '',
        subscriptionId: 0
    };
    const [isEdit, setIsEdit] = useState(false);
    let { id } = useParams();
    const [subscriptionList, setSubscriptionList] = useState([]);
    const getSubscriptionList = async (type) => {
        await OrganisationServices.getSubscriptions(type)
            .then((res) => {
                setSubscriptionList(res.data.data);
                console.log('api response', res.data.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };
    useEffect(async () => {
        await getSubscriptionList('organisation');

        if (id != 0) {
            setIsEdit(true);

            OrganisationServices.getOrganisation(id)
                .then((res) => {
                    delete res.data.data.OrganisationSubscription;
                    console.log('get org by id ', res.data.data);
                    reset(res.data.data);
                })
                .catch((err) => {
                    console.log(err);
                });
        } else {
            setIsEdit(false);
        }
    }, []);

    const saveOrganisation = (data) => {
        console.log(data);
        if (isEdit) {
            OrganisationServices.updateOrganisation(id, data)
                .then((res) => {
                    console.log(res);
                    goToList();
                })
                .catch((err) => {
                    console.log(err);
                });
        } else {
            OrganisationServices.createOrganisation(data)
                .then((res) => {
                    history.push({ pathname: `user/${res.data.data.id}` });
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    };

    const { register, handleSubmit, errors, reset, formState } = useForm({
        mode: 'onBlur',
        defaultValues: defaultOrganisation
    });
    const { isValid } = formState;

    const resetForm = () => {
        reset(defaultOrganisation);
    };

    function goToList() {
        history.push({ pathname: '/organization-accounts' });
    }

    function preventSpecialSymbols(e) {
        let k = e.keyCode;
        if (!(k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || (k >= 48 && k <= 57)) {
            if (k != 8 && k != 32 && k != 9) {
                e.preventDefault();
            }
        }
    }

    return (
        <Base>
            <Breadcrumbs title="Organisation" />
            <div className="row">
                <div className="col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2">
                    <div className="block">
                        <div className="block-title">
                            <h2>Account Details</h2>
                        </div>
                        <form
                            id="form-validation"
                            action="page_forms_validation.html"
                            method="post"
                            className="form-horizontal form-bordered"
                            onSubmit={handleSubmit(saveOrganisation)}>
                            <div className="form-group">
                                <label className="col-md-4 control-label" htmlFor="val-companyname">
                                    Company Name <span className="text-danger">*</span>
                                </label>
                                <div className="col-md-7">
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        maxLength="150"
                                        className="form-control"
                                        placeholder="Enter your company name.."
                                        onKeyDown={(e) => preventSpecialSymbols(e)}
                                        ref={register({ required: true, maxLength: 150 })}
                                    />
                                    {errors.name && errors.name.type === 'required' && errorMessage(required)}
                                    {errors.name && errors.name.type === 'maxLength' && errorMessage(maxLength)}
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="col-md-4 control-label" htmlFor="val-companyname">
                                    Company Description
                                </label>
                                <div className="col-md-7">
                                    <input
                                        type="text"
                                        id="description"
                                        name="description"
                                        className="form-control"
                                        placeholder="Enter your company description.."
                                        maxLength="150"
                                        ref={register({ maxLength: 250 })}
                                    />
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="col-md-4 control-label" htmlFor="val-acctype">
                                    Subscription Type <span className="text-danger">*</span>
                                </label>
                                <div className="col-md-7">
                                    <select
                                        id="subscriptionId"
                                        name="subscriptionId"
                                        className="form-control"
                                        ref={register({ validate: (value) => value != 0 })}>
                                        <option value={0}>Please select</option>
                                        {subscriptionList.length > 0 &&
                                            subscriptionList.map((subs) => (
                                                <option key={subs.id} value={subs.id}>
                                                    {subs.name}
                                                </option>
                                            ))}
                                    </select>
                                    {errors.subscriptionId && errorMessage(required)}
                                </div>
                            </div>
                            <div className="form-group form-actions">
                                <div className="col-md-7 col-md-offset-4">
                                    <button disabled={!isValid} className="btn btn-effect-ripple btn-primary1">
                                        Submit
                                    </button>
                                    {!isEdit ? (
                                        <button
                                            onClick={resetForm}
                                            type="reset"
                                            className="btn btn-effect-ripple btn-danger">
                                            Reset
                                        </button>
                                    ) : (
                                        <button onClick={goToList} className="btn btn-effect-ripple btn-danger">
                                            Back
                                        </button>
                                    )}
                                </div>
                            </div>
                        </form>
                        <div id="modal-terms" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true">
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h3 className="modal-title text-center">
                                            <strong>Terms and Conditions</strong>
                                        </h3>
                                    </div>
                                    <div className="modal-body">
                                        <h4 className="page-header">
                                            1. <strong>General</strong>
                                        </h4>
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ultrices,
                                            justo vel imperdiet gravida, urna ligula hendrerit nibh, ac cursus nibh
                                            sapien in purus. Mauris tincidunt tincidunt turpis in porta. Integer
                                            fermentum tincidunt auctor.
                                        </p>
                                        <h4 className="page-header">
                                            2. <strong>Account</strong>
                                        </h4>
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ultrices,
                                            justo vel imperdiet gravida, urna ligula hendrerit nibh, ac cursus nibh
                                            sapien in purus. Mauris tincidunt tincidunt turpis in porta. Integer
                                            fermentum tincidunt auctor.
                                        </p>
                                        <h4 className="page-header">
                                            3. <strong>Service</strong>
                                        </h4>
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ultrices,
                                            justo vel imperdiet gravida, urna ligula hendrerit nibh, ac cursus nibh
                                            sapien in purus. Mauris tincidunt tincidunt turpis in porta. Integer
                                            fermentum tincidunt auctor.
                                        </p>
                                        <h4 className="page-header">
                                            4. <strong>Payments</strong>
                                        </h4>
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ultrices,
                                            justo vel imperdiet gravida, urna ligula hendrerit nibh, ac cursus nibh
                                            sapien in purus. Mauris tincidunt tincidunt turpis in porta. Integer
                                            fermentum tincidunt auctor.
                                        </p>
                                    </div>
                                    <div className="modal-footer">
                                        <div className="text-center">
                                            <button
                                                type="button"
                                                className="btn btn-effect-ripple btn-primary"
                                                data-dismiss="modal">
                                                I&aposve read them!
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Base>
    );
};
export default CreateUpdateOrgAccount;
